import {BaseWidget} from "./BaseWidget";
import {suggest, updateRelatedFields} from "../actions/BaseDispatcher";
import {displayStringOfSuggestionItem} from "../common/SuggestionItemUtil";
import {fieldAllowedValues} from "../widgets/FieldWidgetCreator";
import {modelId} from "../grid/NamaGridWidget";
import {isNullOrUndefined} from "../common/NamaCommon";
import {EditPresenter} from "../routing/EditPresenter";

export class AutoCompleteWidget extends BaseWidget {
    afterAttach() {
        super.afterAttach();
        let that = this;
        that.model = kendo.data.Model.define({});
        Object.defineProperty(that.model.prototype, "$calcCode", {
            enumerable: false, configurable: true, get: function () {
                return this.text && this.text.code ? this.text.code : "";
            }, set: function (value) {
            }
        });
        that.dataSource = new kendo.data.DataSource({
            serverFiltering: true,
            serverPaging: true,
            transport: {
                read: (options) => {
                    that.active = true;
                    let allowedValues = fieldAllowedValues(that.id, that.presenter());
                    if (allowedValues.length > 0) {
                        options.success(allowedValues);
                        return;
                    }
                    let suggestionList = [];
                    suggest(that.presenter(), that.id, widgetRowIndex(that), that.readValueFromElement(), getSuggestionEntityType(that, that.presenter())).then((result) => {
                        for (let suggestItem of result.suggestions) {
                            suggestionList.push(suggestItem);
                        }
                        options.success(suggestionList);
                    }).catch((e) => options.error(e));
                },
                update: (options) => {
                }
            },
            schema: {
                model: that.model
            }
        });
        that.findElement().kendoAutoComplete({
            autoWidth: true,
            dataTextField: "$calcCode",
            dataSource: that.dataSource,
            select: (e) => {
                if (e.dataItem && e.dataItem.fieldsToUpdate) {
                    updateRelatedFields(e.dataItem.fieldsToUpdate, widgetRowIndex(that), that.presenter());
                }
            },
            open: (e) => {
                that.active = true;
            },
            close: (e) => {
                that.active = false;
            },
            template: displayStringOfSuggestionItem,
        });
        that.findElement().on("keyup", (e) => {
            if (kendo.keys.DOWN == e.keyCode)
                that.startSearch();
        });
        that.findElement().on("dblclick", (e) => {
            that.startSearch();
        });
    }

    startSearch() {
        let that = this;
        if (that.active)
            return;
        let autoComplete = that.findElement().data("kendoAutoComplete");
        autoComplete.search(autoComplete.value());
    }


    presenter() {
        let that = this;
        let presenter = that.owner;
        if (that.cellOptions)
            presenter = that.owner.owner;
        return presenter;
    }
}

export function widgetRowIndex(that) {
    let rowIndex = -1;
    if (that.cellOptions) {
        let rowId = that.cellOptions.model["id"];
        rowIndex = that.owner._getRowIndex(rowId);
    }
    return rowIndex;
}

export function getSuggestionEntityType(widget, presenter) {
    if (widget.cellOptions)
        return widget.cellOptions.model[modelId(widget.id + ".entityType")] || "";
    return isNullOrUndefined(presenter) || !(presenter instanceof EditPresenter) ? "" : presenter.entityType;
}

